// Global Admin

export const processList = {
    // Auth
    login: "gp000001",
    logout: "gp000002",

    // Inst related
    getInsts: "gp010001",
    getAllInsts: "gp010006",
    showInst: "gp010002",
    getBranches: "gp020001",
    showBranch: "gp020002",
    storeBranch: "gp020003",
    updateBranch: "gp020004",
    destroyBranch: "gp020005",

    // Ad inst related
    adGetBranches: "ad010401",
    adGetPositions: "ad010601",
    adShowBranch: "ad010402",
    adStoreBranch: "ad010403",
    adUpdateBranch: "ad010404",
    adDestroyBranch: "ad010405",

    // User related
    getUsers: "gp040001",
    showUser: "gp040002",
    storeUser: "gp040003",
    updateUser: "gp040004",
    destroyUser: "gp040005",
    getUserRoles: "gp040006",
    setUserRoles: "gp040007",
    getUserFlowRoles: "gp040008",
    setUserFlowRoles: "gp040009",

    // User related
    adGetUsers: "ad010501",
    adShowUser: "ad010502",
    adStoreUser: "ad010503",
    adUpdateUser: "ad010504",
    adDestroyUser: "ad010505",
    adGetUserRoles: "ad010506",
    adSetUserRoles: "ad010507",
    adGetUserFlowRoles: "gp040008",
    adSetUserFlowRoles: "gp040009",

    // Role related
    getRoles: "gp030001",
    showRole: "gp030002",
    storeRole: "gp030003",
    updateRole: "gp030004",
    destroyRole: "gp030005",
    getPerms: "gp030006",
    setPerms: "gp030007",

    // AD Role related
    adGetRoles: "ad010301",
    adShowRole: "ad010302",
    adStoreRole: "ad010303",
    adUpdateRole: "ad010304",
    adDestroyRole: "ad010305",
    adGetPerms: "ad010306",
    adSetPerms: "ad010307",

    // Flow related
    getFlows: "ad020901",
    getFlowRoles: "gp011401",
    showFlowRoles: "gp011402",
    storeFlowRoles: "gp011403",
    updateFlowRoles: "gp011404",
    destroyFlowRoles: "gp011405",
    setFlows: "gp011406",
    getFlowDic: "pf000908",
    getRoleFlows: "gp011407",

    // Flow related
    adGetFlows: "ad020901",
    adGetFlowRoles: "ad030901",
    adShowFlowRoles: "ad030902",
    adStoreFlowRoles: "ad030903",
    adUpdateFlowRoles: "ad030904",
    adDestroyFlowRoles: "ad030905",
    adSetFlows: "ad030906",
    adGetFlowDic: "pf000908",
    adGetRoleFlows: "ad030907",

    adGetReportRoles: "ad031101",
    adShowReportRoles: "ad031102",
    adStoreReportRoles: "ad031103",
    adUpdateReportRoles: "ad031104",
    adDestroyReportRoles: "ad031105",
    adSetReports: "ad031106",
    adGetReportDic: "pf001906",
    adGetRoleReports: "ad031107",

    // Process code
    getProcessCodes: "gp010801",
    adGetProcessCodes: "ad030801",

    // Dictionary
    getDictionary: "gp010706",

    // Menu
    getMenu: "gp011101",

    // Modules
    getModule: "gp011001",
    showModule: "gp011002",
    storeModule: "gp011003",
    updateModule: "gp011004",
    destroyModule: "gp011005",
    getAllModule: "gp011006",

    // App
    getApp: "gp011201",
    showApp: "gp011202",
    storeApp: "gp011203",
    updateApp: "gp011204",
    destroyApp: "gp011205",
    getAllApp: "gp011206",

    // App
    adGetApp: "ad030701",
    adShowApp: "ad030702",
    adStoreApp: "ad030703",
    adUpdateApp: "ad030704",
    adDestroyApp: "ad030705",
    adGetAllApp: "ad030706",

    // App param
    getAppParam: "gp011301",
    showAppParam: "gp011302",
    storeAppParam: "gp011303",
    updateAppParam: "gp011304",
    destroyAppParam: "gp011305",

    // AD App param
    adGetAppParam: "ad031001",
    adShowAppParam: "ad031002",
    adStoreAppParam: "ad031003",
    adUpdateAppParam: "ad031004",
    adDestroyAppParam: "ad031005",

    // Admin menu
    getMenuList: "ad030101",
    showMenu: "ad030102",
    storeMenu: "ad030103",
    updateMenu: "ad030104",
    destroyMenu: "ad030105",
    setMenuUser: "ad030106",

    // FlowStepItem
    getFlowStepItems: "pf001201",
    getFlowStepItems1: "pf001207",
    setFlowStepItems: "pf001206",
    // Мэдэгдэл (NotifController). Backend нь аль хэдийн байсан ч frontend
    // талаасаа хэзээ ч дуудагдаагүй. `ad030302` нь хонхны badge-д зориулсан
    // (контроллерын тайлбарт тэгж бичсэн).
    // ⚠ Эдгээрийг `useAuth().api`-аар дуудахгүй — тэр нь LoadingContext руу
    // dispatch хийдэг тул 60 секундын poll нь глобал loading-ийг анивчуулна.
    notifList: "ad030301",
    notifCount: "ad030302",
    notifMarkRead: "ad030304",

    // Мэдэгдлийн дүрэм — урсгалын дизайнер дотор (NotifyConfigController).
    // ⚠ pf0026xx БИШ: тэр блокийг `improvement` салаа аваад байна.
    notifyMentionable: "pf002701",
    notifyRuleList: "pf002702",
    notifyRuleShow: "pf002703",
    notifyRuleStore: "pf002704",
    notifyRuleUpdate: "pf002705",
    notifyRuleDestroy: "pf002706",
    notifyRulePreview: "pf002707",
    // ⚠ gp020001 БИШ: тэр нь instid-г хүсэлтээс авдаг бөгөөд зөвхөн
    // «Систем админ» дүрд өгөгдсөн — урсгал зохиогчид хоосон гарна.
    notifyBranches: "pf002708",

    getCustomComponents: "pf000101",
    getCustomComponentsUser: "pf000106",

    // Log related
    getErrorLogList: "gp011801",
    getErrorLogDetail: "gp011802",
    getChangeLogList: "gp011901",
    getChangeLogDetail: "gp011902",
    getMailLogList: "gp012001",
    
    //Dynamic flow 
    getDynamicFlow:"pf000501",
    showDynamicFlow:"pf000502",
    storeDynamicFlow:"pf000503",
    updateDynamicFlow:"pf000504",
    destroyDynamicFlow:"pf000505",
    getAllDynamicFlow:"pf000506",


    // Const
    getConst:"gp010601",
    showConst:"gp010602",
    storeConst:"gp010603",
    updateConst:"gp010604",
    destroyConst:"gp010605",

    // FlowStepItem Value show
    getFlowStepItemValues: "pf001208",
    // Процессын тойм: үйлдлийн лог, алхмууд, API утгууд
    processOverview: "pf001209",
    // Нэг үйлдлийн гүйцэтгэлийн түүх (үйлдэл засах цонх).
    actionHistory: "pf001210",
}
